
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { MethodType, MethodTypes, SoaType, SoaTypes } from '../../models/method-soa'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { FormValidationService } from '../../../validations/form-validation-service'
import { Router, ActivatedRoute } from '@angular/router'

@Component({

    selector: 'EnrollmentMethodSoa',
    templateUrl: './enrollment-method-and-soa.component.html'
})
export class EnrollmentMethodAndSoaComponent implements OnInit, OnDestroy {
    orgID = '9'
    enrollmentViewModel: EnrollmentViewModel = {} as EnrollmentViewModel
    methodOption: string
    soaComplete: string
    notBlankValidator = new NotBlankGenericFieldValidator()

    constructor(private _enrollmentGateway: EnrollmentGateway,
        private _userAccessGateway: UserAccessGateway,
        private _validationService: FormValidationService,
        private _routers: Router

    ) {

    }



    EnrollmentMethodOptions: ValidatedRadioButtonModel[] = Object.keys(MethodTypes).map((methodTypeKey) => {
        return { value: methodTypeKey, htmlLabel: MethodTypes[methodTypeKey] }
    })

    SoaOptions: ValidatedRadioButtonModel[] = Object.keys(SoaTypes).map((soaTypeKey) => {
        return { value: soaTypeKey, htmlLabel: SoaTypes[soaTypeKey] }
    })

    EnrollmentMethodChange(option: string) {
        this.methodOption = this.enrollmentViewModel.AGENTDEX = option
    }
    isSoaCompleteChange(option: string) {

        this.soaComplete = this.enrollmentViewModel.SOA = option
    }
    ngOnInit() {
        this._userAccessGateway.getCurrentUser().subscribe(currentUser => {
            this.orgID = currentUser.orgId
        })
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
    }

    ngOnDestroy() {
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
    }

    validateForm() {
        this._validationService.validateAll(
            () => {
                let url = '/enrollment/external-agent'
                this._routers.navigateByUrl(url)
            },
            () => { }
        )
    }

}